import React, { useEffect, useRef, useState } from 'react';

type TQuickActionsProps = {
    actions: any[];
}

export function QuickActions({
    actions,
}: TQuickActionsProps) {
    const [isExpanded, setIsExpanded] = useState(false);
    const menuRef = useRef(null);

    // Close menu when clicking outside or on an action item
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsExpanded(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.querySelectorAll('.action-item')?.forEach(item => {
            item.addEventListener('click', () => setIsExpanded(false));
        });
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.querySelectorAll('.action-item')?.forEach(item => {
                item.removeEventListener('click', () => setIsExpanded(false));
            });
        };
    }, []);

    return (
        <div className="quick-actions-container" ref={menuRef}>
            {/* Main Toggle Button */}
            <button
                className={`quick-actions-toggle ${isExpanded ? 'expanded' : ''}`}
                type="button"
                onClick={() => setIsExpanded(!isExpanded)}
                aria-expanded={isExpanded}
                aria-label="Quick actions menu"
            >
                <span className="quick-actions-toggle-label">Quick Actions</span>
                <span className={`quick-actions-toggle-chevron ${isExpanded ? 'rotated' : ''}`}>▼</span>
            </button>

            {/* Expandable Menu */}
            <div className={`quick-actions-menu ${isExpanded ? 'expanded' : ''}`}>
                {actions}
            </div>
        </div>
    );
}

type TQuickActionItemProps = {
    label: string;
    icon: string;
    onClick: () => void;
}

export function QuickActionItem({
    label,
    icon,
    onClick,
}: TQuickActionItemProps) {

    return (
        <button
            className="action-item"
            type="button"
            onClick={onClick}
            aria-label={label}
        >
            <span className="quick-actions-action-icon">
                <i className={`icon ${icon}`}/>
            </span>
            <span className="quick-actions-action-label">
                {label}
            </span>
        </button>
    );
}
